/* eslint-disable react/no-unescaped-entities */
import {
    documentExpiry,
    getAnniversary,
    getAnnouncementList,
    getBirthday,
    getEmployeeLeaveStatus,
    getNewJoiners,
    getPublicHoliday,
    getTerminated
} from "api/services/dashboard";
import Image from "components/Image";
import { SkeltonLoader } from "components/skeltonLoader";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
    holidaycalendar
} from "../../../../../Routes/ImagePath";
import "./style/dashboardStyle.css";

import { Popover } from 'antd';
import Carousel from 'react-bootstrap/Carousel';
import { formatBirthdayHandler, formatDateHandler } from "utils/common";
import { imageKitResize } from "utils/imageKit";
// import ExampleCarouselImage from 'components/ExampleCarouselImage';

const DocumentExpiryCard = ({ title, data, filter, setFilter, loading, type, icon }) => {
  const gradientColors = "linear-gradient(135deg, #fef3c7 0%, #fde68a 50%, #fcd34d 100%)";
  const accentColor = "#f59e0b";
  const iconBg = "linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)";

  return (
    <div 
      className="card flex-fill" 
      style={{ 
        borderRadius: "16px", 
        border: "none",
        background: gradientColors,
        boxShadow: "0 4px 20px rgba(245, 158, 11, 0.08), 0 2px 8px rgba(245, 158, 11, 0.06)",
        overflow: "hidden",
        position: "relative"
      }}
    >
      {/* Decorative background elements */}
      <div 
        style={{
          position: "absolute",
          top: "-20px",
          right: "-20px",
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(251, 191, 36, 0.1) 100%)",
          zIndex: 0
        }}
      />

      <div className="card-body p-3" style={{ position: "relative", zIndex: 1 }}>
        <div className="d-flex align-items-center mb-3">
          <div 
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "10px",
              background: iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 3px 10px rgba(245, 158, 11, 0.2)",
              marginRight: "10px"
            }}
          >
            <i className={`fa ${type === "user" ? "fa-user" : "fa-store"}`} style={{ fontSize: "18px", color: "#ffffff" }}></i>
          </div>
          <h5 className="mb-0" style={{ fontSize: "16px", fontWeight: "700", color: "#1a1a1a" }}>
            {title}
          </h5>
        </div>
        
        {loading ? (
          <SkeltonLoader number={4} active={true} className="col-12" height={40} />
        ) : (
          <div className="d-flex flex-column gap-2">
            <div 
              className="d-flex justify-content-between align-items-center p-2" 
              style={{
                backgroundColor: "#ffffff", 
                borderRadius: "10px",
                border: `1px solid ${data.expiry_today > 0 ? accentColor : "#e5e7eb"}`,
                boxShadow: data.expiry_today > 0 ? "0 2px 8px rgba(245, 158, 11, 0.1)" : "0 1px 3px rgba(0, 0, 0, 0.05)",
                transition: "all 0.2s ease"
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div 
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: data.expiry_today > 0 ? accentColor : "#9ca3af"
                  }}
                />
                <span style={{ fontSize: "13px", fontWeight: "600", color: "#1a1a1a" }}>Expiring Today</span>
              </div>
              <span 
                className="badge rounded-pill" 
                style={{ 
                  fontSize: "12px", 
                  padding: "4px 10px",
                  fontWeight: "600",
                  backgroundColor: data.expiry_today > 0 ? accentColor : "#9ca3af",
                  color: "#ffffff"
                }}
              >
                {data.expiry_today || 0}
              </span>
            </div>
            <div 
              className="d-flex justify-content-between align-items-center p-2"
              style={{
                backgroundColor: "#ffffff", 
                borderRadius: "10px",
                border: `1px solid ${data.expiry_in_30_days > 0 ? accentColor : "#e5e7eb"}`,
                boxShadow: data.expiry_in_30_days > 0 ? "0 2px 8px rgba(245, 158, 11, 0.1)" : "0 1px 3px rgba(0, 0, 0, 0.05)",
                transition: "all 0.2s ease"
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div 
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: data.expiry_in_30_days > 0 ? accentColor : "#9ca3af"
                  }}
                />
                <span style={{ fontSize: "13px", fontWeight: "600", color: "#1a1a1a" }}>Expiring in 30 Days</span>
              </div>
              <span 
                className="badge rounded-pill" 
                style={{ 
                  fontSize: "12px", 
                  padding: "4px 10px",
                  fontWeight: "600",
                  backgroundColor: data.expiry_in_30_days > 0 ? accentColor : "#9ca3af",
                  color: "#ffffff"
                }}
              >
                {data.expiry_in_30_days || 0}
              </span>
            </div>
            <div 
              className="d-flex justify-content-between align-items-center p-2"
              style={{
                backgroundColor: "#ffffff", 
                borderRadius: "10px",
                border: `1px solid ${data.expiry_in_60_days > 0 ? accentColor : "#e5e7eb"}`,
                boxShadow: data.expiry_in_60_days > 0 ? "0 2px 8px rgba(245, 158, 11, 0.1)" : "0 1px 3px rgba(0, 0, 0, 0.05)",
                transition: "all 0.2s ease"
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div 
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: data.expiry_in_60_days > 0 ? accentColor : "#9ca3af"
                  }}
                />
                <span style={{ fontSize: "13px", fontWeight: "600", color: "#1a1a1a" }}>Expiring in 60 Days</span>
              </div>
              <span 
                className="badge rounded-pill" 
                style={{ 
                  fontSize: "12px", 
                  padding: "4px 10px",
                  fontWeight: "600",
                  backgroundColor: data.expiry_in_60_days > 0 ? accentColor : "#9ca3af",
                  color: "#ffffff"
                }}
              >
                {data.expiry_in_60_days || 0}
              </span>
            </div>
            <div 
              className="d-flex justify-content-between align-items-center p-2"
              style={{
                backgroundColor: "#ffffff", 
                borderRadius: "10px",
                border: `1px solid ${data.expiry_in_90_days > 0 ? accentColor : "#e5e7eb"}`,
                boxShadow: data.expiry_in_90_days > 0 ? "0 2px 8px rgba(245, 158, 11, 0.1)" : "0 1px 3px rgba(0, 0, 0, 0.05)",
                transition: "all 0.2s ease"
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div 
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: data.expiry_in_90_days > 0 ? accentColor : "#9ca3af"
                  }}
                />
                <span style={{ fontSize: "13px", fontWeight: "600", color: "#1a1a1a" }}>Expiring in 90 Days</span>
              </div>
              <span 
                className="badge rounded-pill" 
                style={{ 
                  fontSize: "12px", 
                  padding: "4px 10px",
                  fontWeight: "600",
                  backgroundColor: data.expiry_in_90_days > 0 ? accentColor : "#9ca3af",
                  color: "#ffffff"
                }}
              >
                {data.expiry_in_90_days || 0}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const EmployeeDashboard = () => {

  // const [menu, setMenu] = useState(false);

  // const toggleMobileMenu = () => {
  //   setMenu(!menu);
  // };

  const { user } = useSelector((state) => state.user);

  const [publicHoliday, setPublicHoliday] = useState([]);
  const [birthdays, setBirthDays] = useState([]);
  const [birthdayLoading, setBirthdayLoading] = useState(true);

  const [anniversary, setAnniversary] = useState([]);
  const [anniversaryLoading, setAnniversaryLoading] = useState(true);

  const [newJoiners, setnewJoiners] = useState([]);
  const [newJoinersLoading, setNewJoinersLoading] = useState(true);

  const [terminated, setTerminated] = useState([]);
  const [terminatedLoading, setTerminatedLoading] = useState(true);

  const [greeting, setGreeting] = useState("");

  // Load filters from localStorage, default to "today"
  const [anniversaryFilter, setAnniversaryFilter] = useState(() => {
    return localStorage.getItem("anniversaryFilter") || "today";
  });
  const [birthdayFilter, setBirthdayFilter] = useState(() => {
    return localStorage.getItem("birthdayFilter") || "today";
  });
  const [leaveFilter, setLeaveFilter] = useState(() => {
    return localStorage.getItem("leaveFilter") || "today";
  });

  const [leaves, setLeaves] = useState([]);
  const [leavesLoading, setLeavesLoading] = useState(true);

  const [userDocumentExpiry, setUserDocumentExpiry] = useState({
    expiry_today: 0,
    expiry_in_30_days: 0,
    expiry_in_60_days: 0, 
    expiry_in_90_days: 0
  });

  const [storeDocumentExpiry, setStoreDocumentExpiry] = useState({
    expiry_today: 0,
    expiry_in_30_days: 0,
    expiry_in_60_days: 0,
    expiry_in_90_days: 0
  });

  const [userExpiryFilter, setUserExpiryFilter] = useState("today");
  const [storeExpiryFilter, setStoreExpiryFilter] = useState("today");
  const [documentExpiryLoading, setDocumentExpiryLoading] = useState(true);

  const [openPopoverIds, setOpenPopoverIds] = useState([]);

  const [announcements, setAnnouncements] = useState([]);
  const [announcementsLoading, setAnnouncementsLoading] = useState(true);


  const fetchAnniversaryData = useCallback((value) => {
    setAnniversaryLoading(true); // Show loader before API call
    getAnniversary(null, { day_filter: value })
      .then((response) => {
        setAnniversary(response.data);
        setAnniversaryLoading(false);
      })
      .catch(() => {
        setAnniversaryLoading(false);
      });
  }, []);

  const fetchBirthdayData = useCallback((value) => {
    setBirthdayLoading(true); // Show loader before API call
    getBirthday(null, { day_filter: value })
      .then((response) => {
        setBirthDays(response.data);
        setBirthdayLoading(false);
      })
      .catch(() => {
        setBirthdayLoading(false);
      });
  }, []);

  const fetchData = useCallback(() => {
    getPublicHoliday().then((response) => {
      setPublicHoliday(response.data.results);
    });

    fetchAnniversaryData(anniversaryFilter);
    fetchBirthdayData(birthdayFilter);

    getNewJoiners()
      .then((response) => {
        setnewJoiners(response.data);
        setNewJoinersLoading(false);
      })
      .catch(() => {
        setNewJoinersLoading(false);
      });

    getTerminated()
      .then((response) => {
        setTerminated(response.data);
        setTerminatedLoading(false);
      })
      .catch(() => {
        setTerminatedLoading(false);
      });

    getAnnouncementList()
      .then((response) => {
        console.log("Raw announcement response:", response);
        // Handle both array and object responses
        const announcementsData = Array.isArray(response.data) 
          ? response.data 
          : response.data?.results || response.data?.data || [];
        
        console.log("Processed announcements data:", announcementsData);
        
        // Sort announcements by order field and filter by status
        const sortedAnnouncements = announcementsData
          .filter(announcement => announcement.status === true)
          .sort((a, b) => (a.order || 0) - (b.order || 0));
        
        console.log("Final sorted announcements:", sortedAnnouncements);
        if (sortedAnnouncements.length > 0) {
          console.log("First announcement:", sortedAnnouncements[0]);
          console.log("First announcement image URL:", sortedAnnouncements[0]?.image);
        }
        
        setAnnouncements(sortedAnnouncements);
        setAnnouncementsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching announcements:", error);
        setAnnouncementsLoading(false);
      });

  }, [anniversaryFilter, birthdayFilter, fetchAnniversaryData, fetchBirthdayData]);

  const getLeaveData = (param) => {
    setLeavesLoading(true);
    getEmployeeLeaveStatus(param)
      .then((response) => {
        setLeaves(response.data);
        setLeavesLoading(false);
      })
      .catch(() => {
        setLeavesLoading(false);
      });
  };
  useEffect(() => {
    getLeaveData({ day_filter: leaveFilter });
  }, [leaveFilter]);

  const fetchDocumentExpiryData = () => {
    setDocumentExpiryLoading(true);
    documentExpiry()
      .then(response => {
        setUserDocumentExpiry(response.data.user_document || {
          expiry_today: 0,
          expiry_in_30_days: 0,
          expiry_in_60_days: 0,
          expiry_in_90_days: 0
        });
        
        setStoreDocumentExpiry(response.data.store_document || {
          expiry_today: 0,
          expiry_in_30_days: 0,
          expiry_in_60_days: 0,
          expiry_in_90_days: 0
        });
        
        setDocumentExpiryLoading(false);
      })
      .catch(error => {
        console.error("Error fetching document expiry data:", error);
        setDocumentExpiryLoading(false);
      });
  };

  const fetchDataMemoized = useCallback(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    fetchDataMemoized();
    fetchDocumentExpiryData();
  }, [fetchDataMemoized]);


  useEffect(() => {
    const getGreeting = () => {
      const currentHour = new Date().getHours(); // Get the current hour (0-23)
      if (currentHour < 12) {
        return "Good Morning";
      } else if (currentHour < 18) {
        return "Good Afternoon";
      } else {
        return "Good Evening";
      }
    };

    setGreeting(getGreeting());
  }, []); // Empty dependency array ensures it runs only once when the component mounts

  // const displayTitleSubText = (type, count) => {
  //   var subText = "";
  //   var employeeText = count === 1 ? "employee" : "employees"
  //   var hasText = count === 1 ? "has" : "have";
  //   var isText  = count === 1 ? "is" : "are";
  //   // var wasText  = count === 1 ? "was" : "were";

  //   if (type === "anniversary") {
  //     subText = " "+ employeeText + " " + isText + " celebrating work anniversary";
  //   } else if (type === "birthday") {
  //     subText = " "+ employeeText + " " + isText + " celebrating birthday";
  //   } else if (type === "terminated") {
  //     subText = " "+ employeeText + " resigned in last 30 days";
  //   } else if(type === "new_joiners") {
  //     subText = " "+ employeeText + " " + hasText + " joined in last 30 days";
  //   }
  //   return subText;
  // }
 

  // Modern Birthday Card Component
  const BirthdayCard = ({ loading, list, count }) => {
    const [isFetching, setIsFetching] = useState(false);

    const handleFilterChange = async (e) => {
      const newValue = e.target.value;
      setIsFetching(true);
      setBirthdayFilter(newValue);
      localStorage.setItem("birthdayFilter", newValue);
      await fetchBirthdayData(newValue);
      setTimeout(() => {
        setIsFetching(false);
      }, 1200);
    };

    return (
      <div 
        className="card flex-fill" 
        style={{ 
          borderRadius: "16px", 
          border: "none",
          background: "linear-gradient(135deg, #fff5f5 0%, #fffbf0 50%, #fff5e6 100%)",
          boxShadow: "0 4px 20px rgba(211, 0, 26, 0.08), 0 2px 8px rgba(245, 158, 11, 0.06)",
          overflow: "hidden",
          position: "relative"
        }}
      >
        {/* Decorative background elements */}
        <div 
          style={{
            position: "absolute",
            top: "-30px",
            right: "-30px",
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(211, 0, 26, 0.1) 0%, rgba(245, 158, 11, 0.1) 100%)",
            zIndex: 0
          }}
        />
        <div 
          style={{
            position: "absolute",
            bottom: "-20px",
            left: "-20px",
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(251, 191, 36, 0.1) 0%, rgba(211, 0, 26, 0.08) 100%)",
            zIndex: 0
          }}
        />

        <div className="card-body d-flex flex-column p-3" style={{ position: "relative", zIndex: 1 }}>
          {/* Header Section */}
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="d-flex align-items-center gap-2">
              <div 
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 3px 10px rgba(211, 0, 26, 0.2)"
                }}
              >
                <i className="fa fa-birthday-cake" style={{ fontSize: "18px", color: "#ffffff" }}></i>
              </div>
              <div>
                <h5 className="mb-0" style={{ fontSize: "16px", fontWeight: "700", color: "#1a1a1a", margin: 0, lineHeight: "1.2" }}>
                  Birthdays
                </h5>
                <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500" }}>
                  {isFetching || loading ? (
                    <div className="shimmer shimmer-text" style={{width: "120px", height: "12px", borderRadius: "4px"}}></div>
                  ) : (
                    `${count} ${count === 1 ? "employee is" : "employees are"} celebrating`
                  )}
                </span>
              </div>
            </div>
  
            {/* Modern Dropdown */}
            <div>
              <select
                className="form-select form-select-sm"
                style={{ 
                  width: "120px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  fontSize: "12px",
                  padding: "4px 28px 4px 10px",
                  fontWeight: "500",
                  color: "#374151",
                  background: "#ffffff",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                value={birthdayFilter}
                onChange={handleFilterChange}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = "#D3001A";
                  e.target.style.boxShadow = "0 2px 6px rgba(211, 0, 26, 0.1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = "#e5e7eb";
                  e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                }}
              >
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
              </select>
            </div>
          </div>
  
          {/* Loading State */}
          {(loading || isFetching) && (
            <div className="d-flex gap-2" style={{ marginTop: "4px" }}>
              {[1, 2, 3].map((i) => (
                <div 
                  key={i}
                  style={{
                    width: "140px",
                    minWidth: "140px",
                    height: "130px",
                    borderRadius: "10px",
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb"
                  }}
                >
                  <SkeltonLoader number={1} active={true} className="col-12" height={130} />
                </div>
              ))}
            </div>
          )}
  
          {/* Birthday Cards */}
          {!loading && !isFetching && (
            <div 
              className="d-flex gap-2" 
              style={{ 
                marginTop: "4px",
                overflowX: "auto",
                paddingBottom: "4px",
                scrollbarWidth: "thin",
                scrollbarColor: "#fbbf24 #fef3c7"
              }}
            >
              {list.length === 0 ? (
                <div 
                  className="d-flex flex-column align-items-center justify-content-center w-100"
                  style={{ 
                    minHeight: "140px",
                    padding: "24px 16px",
                    textAlign: "center"
                  }}
                >
                  <div 
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, rgba(211, 0, 26, 0.1) 0%, rgba(245, 158, 11, 0.1) 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "12px"
                    }}
                  >
                    <i className="fa fa-birthday-cake" style={{ fontSize: "28px", color: "#f59e0b" }}></i>
                  </div>
                  <h6 style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>
                    No Birthdays
                  </h6>
                  <p style={{ fontSize: "12px", color: "#6b7280", margin: 0 }}>
                    No birthdays {birthdayFilter === "today" ? "today" : birthdayFilter === "week" ? "this week" : "this month"}
                  </p>
                </div>
              ) : (
                list.map((item, index) => (
                  <div 
                    key={index} 
                    style={{ 
                      minWidth: "140px",
                      width: "140px",
                      borderRadius: "12px",
                      background: "#ffffff",
                      border: "1px solid #fef3c7",
                      padding: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      position: "relative",
                      overflow: "visible"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(211, 0, 26, 0.12)";
                      e.currentTarget.style.borderColor = "#fbbf24";
                      e.currentTarget.style.borderWidth = "1px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.04)";
                      e.currentTarget.style.borderColor = "#fef3c7";
                      e.currentTarget.style.borderWidth = "1px";
                    }}
                    onClick={() => window.location.href = `/company-directory/${item.id}`}
                  >
                    {/* Avatar */}
                    <div className="d-flex justify-content-center mb-2">
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          background: "#f0f0f0"
                        }}
                      >
                        <Image 
                          src={item?.profile_image} 
                          type="user" 
                          style={{ 
                            objectFit: "cover",
                            width: "100%",
                            height: "100%"
                          }} 
                        />
                      </div>
                    </div>

                    {/* Name and Details */}
                    <div className="text-center">
                      <Link 
                        to={`/company-directory/${item.id}`}
                        style={{
                          textDecoration: "none",
                          color: "#1a1a1a",
                          fontWeight: "400",
                          fontSize: "13px",
                          display: "block",
                          marginBottom: "3px",
                          transition: "color 0.2s ease",
                          lineHeight: "1.3",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        onMouseEnter={(e) => e.target.style.color = "#D3001A"}
                        onMouseLeave={(e) => e.target.style.color = "#1a1a1a"}
                      >
                        {item?.first_name} {item?.last_name}
                      </Link>
                      {item?.emp_no && (
                        <span 
                          style={{ 
                            fontSize: "11px", 
                            color: "#6b7280",
                            fontWeight: "500",
                            display: "block",
                            marginBottom: "8px"
                          }}
                        >
                          {item?.emp_no}
                        </span>
                      )}
                      
                      {/* Birthday Date */}
                      <div 
                        style={{
                          padding: "6px 10px",
                          borderRadius: "6px",
                          background: "linear-gradient(135deg, rgba(211, 0, 26, 0.05) 0%, rgba(245, 158, 11, 0.05) 100%)",
                          border: "1px solid #fef3c7"
                        }}
                      >
                        <div style={{ fontSize: "10px", color: "#6b7280", fontWeight: "500", marginBottom: "2px" }}>
                          Birthday
                        </div>
                        <div style={{ fontSize: "11px", color: "#D3001A", fontWeight: "600" }}>
                          {formatBirthdayHandler(item.birthday)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        <style>{`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.1);
              opacity: 0.9;
            }
          }
        `}</style>
      </div>
    );
  };

  // Modern Work Anniversary Card Component
  const AnniversaryCard = ({ loading, list, count }) => {
    const [isFetching, setIsFetching] = useState(false);

    const handleFilterChange = async (e) => {
      const newValue = e.target.value;
      setIsFetching(true);
      setAnniversaryFilter(newValue);
      localStorage.setItem("anniversaryFilter", newValue);
      await fetchAnniversaryData(newValue);
      setTimeout(() => {
        setIsFetching(false);
      }, 1200);
    };

    return (
      <div 
        className="card flex-fill" 
        style={{ 
          borderRadius: "16px", 
          border: "none",
          background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 50%, #dbeafe 100%)",
          boxShadow: "0 4px 20px rgba(59, 130, 246, 0.08), 0 2px 8px rgba(59, 130, 246, 0.06)",
          overflow: "hidden",
          position: "relative"
        }}
      >
        {/* Decorative background elements */}
        <div 
          style={{
            position: "absolute",
            top: "-30px",
            right: "-30px",
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(96, 165, 250, 0.1) 100%)",
            zIndex: 0
          }}
        />
        <div 
          style={{
            position: "absolute",
            bottom: "-20px",
            left: "-20px",
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.08) 100%)",
            zIndex: 0
          }}
        />

        <div className="card-body d-flex flex-column p-3" style={{ position: "relative", zIndex: 1 }}>
          {/* Header Section */}
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="d-flex align-items-center gap-2">
              <div 
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 3px 10px rgba(59, 130, 246, 0.2)"
                }}
              >
                <i className="fa fa-calendar-check" style={{ fontSize: "18px", color: "#ffffff" }}></i>
              </div>
              <div>
                <h5 className="mb-0" style={{ fontSize: "16px", fontWeight: "700", color: "#1a1a1a", margin: 0, lineHeight: "1.2" }}>
                  Work Anniversary
                </h5>
                <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500" }}>
                  {isFetching || loading ? (
                    <div className="shimmer shimmer-text" style={{width: "120px", height: "12px", borderRadius: "4px"}}></div>
                  ) : (
                    `${count} ${count === 1 ? "employee is" : "employees are"} celebrating`
                  )}
                </span>
              </div>
            </div>
  
            {/* Modern Dropdown */}
            <div>
              <select
                className="form-select form-select-sm"
                style={{ 
                  width: "120px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  fontSize: "12px",
                  padding: "4px 28px 4px 10px",
                  fontWeight: "500",
                  color: "#374151",
                  background: "#ffffff",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                value={anniversaryFilter}
                onChange={handleFilterChange}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = "#3b82f6";
                  e.target.style.boxShadow = "0 2px 6px rgba(59, 130, 246, 0.1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = "#e5e7eb";
                  e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                }}
              >
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
              </select>
            </div>
          </div>
  
          {/* Loading State */}
          {(loading || isFetching) && (
            <div className="d-flex gap-2" style={{ marginTop: "4px" }}>
              {[1, 2, 3].map((i) => (
                <div 
                  key={i}
                  style={{
                    width: "140px",
                    minWidth: "140px",
                    height: "130px",
                    borderRadius: "10px",
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb"
                  }}
                >
                  <SkeltonLoader number={1} active={true} className="col-12" height={130} />
                </div>
              ))}
            </div>
          )}
  
          {/* Anniversary Cards */}
          {!loading && !isFetching && (
            <div 
              className="d-flex gap-2" 
              style={{ 
                marginTop: "4px",
                overflowX: "auto",
                paddingBottom: "4px",
                scrollbarWidth: "thin",
                scrollbarColor: "#60a5fa #dbeafe"
              }}
            >
              {list.length === 0 ? (
                <div 
                  className="d-flex flex-column align-items-center justify-content-center w-100"
                  style={{ 
                    minHeight: "140px",
                    padding: "24px 16px",
                    textAlign: "center"
                  }}
                >
                  <div 
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(96, 165, 250, 0.1) 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "12px"
                    }}
                  >
                    <i className="fa fa-calendar-check" style={{ fontSize: "28px", color: "#3b82f6" }}></i>
                  </div>
                  <h6 style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>
                    No Anniversaries
                  </h6>
                  <p style={{ fontSize: "12px", color: "#6b7280", margin: 0 }}>
                    No anniversaries {anniversaryFilter === "today" ? "today" : anniversaryFilter === "week" ? "this week" : "this month"}
                  </p>
                </div>
              ) : (
                list.map((item, index) => (
                  <div 
                    key={index} 
                    style={{ 
                      minWidth: "140px",
                      width: "140px",
                      borderRadius: "12px",
                      background: "#ffffff",
                      border: "1px solid #dbeafe",
                      padding: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      position: "relative",
                      overflow: "visible"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(59, 130, 246, 0.12)";
                      e.currentTarget.style.borderColor = "#60a5fa";
                      e.currentTarget.style.borderWidth = "1px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.04)";
                      e.currentTarget.style.borderColor = "#dbeafe";
                      e.currentTarget.style.borderWidth = "1px";
                    }}
                    onClick={() => window.location.href = `/company-directory/${item.id}`}
                  >
                    {/* Avatar */}
                    <div className="d-flex justify-content-center mb-2">
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          background: "#f0f0f0"
                        }}
                      >
                        <Image 
                          src={item?.profile_image} 
                          type="user" 
                          style={{ 
                            objectFit: "cover",
                            width: "100%",
                            height: "100%"
                          }} 
                        />
                      </div>
                    </div>

                    {/* Name and Details */}
                    <div className="text-center">
                      <Link 
                        to={`/company-directory/${item.id}`}
                        style={{
                          textDecoration: "none",
                          color: "#1a1a1a",
                          fontWeight: "400",
                          fontSize: "13px",
                          display: "block",
                          marginBottom: "3px",
                          transition: "color 0.2s ease",
                          lineHeight: "1.3",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        onMouseEnter={(e) => e.target.style.color = "#3b82f6"}
                        onMouseLeave={(e) => e.target.style.color = "#1a1a1a"}
                      >
                        {item?.first_name} {item?.last_name}
                      </Link>
                      {item?.emp_no && (
                        <span 
                          style={{ 
                            fontSize: "11px", 
                            color: "#6b7280",
                            fontWeight: "500",
                            display: "block",
                            marginBottom: "8px"
                          }}
                        >
                          {item?.emp_no}
                        </span>
                      )}
                      
                      {/* Anniversary Info */}
                      <div 
                        style={{
                          padding: "6px 10px",
                          borderRadius: "6px",
                          background: "linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(96, 165, 250, 0.05) 100%)",
                          border: "1px solid #dbeafe"
                        }}
                      >
                        <div style={{ fontSize: "10px", color: "#6b7280", fontWeight: "500", marginBottom: "2px" }}>
                          {item.job_anniversary_count || "Years"}
                        </div>
                        <div style={{ fontSize: "11px", color: "#3b82f6", fontWeight: "600" }}>
                          {formatDateHandler(item.employment_date)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        <style>{`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.1);
              opacity: 0.9;
            }
          }
        `}</style>
      </div>
    );
  };

  // Modern New Joiners Card Component
  const NewJoinersCard = ({ loading, list, count }) => {
    return (
      <div 
        className="card flex-fill" 
        style={{ 
          borderRadius: "16px", 
          border: "none",
          background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, #bbf7d0 100%)",
          boxShadow: "0 4px 20px rgba(16, 185, 129, 0.08), 0 2px 8px rgba(16, 185, 129, 0.06)",
          overflow: "hidden",
          position: "relative"
        }}
      >
        {/* Decorative background elements */}
        <div 
          style={{
            position: "absolute",
            top: "-30px",
            right: "-30px",
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(34, 197, 94, 0.1) 100%)",
            zIndex: 0
          }}
        />

        <div className="card-body d-flex flex-column p-3" style={{ position: "relative", zIndex: 1 }}>
          {/* Header Section */}
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="d-flex align-items-center gap-2">
              <div 
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #10b981 0%, #22c55e 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 3px 10px rgba(16, 185, 129, 0.2)"
                }}
              >
                <i className="fa fa-user-plus" style={{ fontSize: "18px", color: "#ffffff" }}></i>
              </div>
              <div>
                <h5 className="mb-0" style={{ fontSize: "16px", fontWeight: "700", color: "#1a1a1a", margin: 0, lineHeight: "1.2" }}>
                  New Joiners
                </h5>
                <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500" }}>
                  {loading ? (
                    <div className="shimmer shimmer-text" style={{width: "120px", height: "12px", borderRadius: "4px"}}></div>
                  ) : (
                    `${count} ${count === 1 ? "employee has" : "employees have"} joined in last 30 days`
                  )}
                </span>
              </div>
            </div>
          </div>
  
          {/* Loading State */}
          {loading && (
            <div className="d-flex gap-2" style={{ marginTop: "4px" }}>
              {[1, 2, 3].map((i) => (
                <div 
                  key={i}
                  style={{
                    width: "140px",
                    minWidth: "140px",
                    height: "130px",
                    borderRadius: "10px",
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb"
                  }}
                >
                  <SkeltonLoader number={1} active={true} className="col-12" height={130} />
                </div>
              ))}
            </div>
          )}
  
          {/* New Joiners Cards */}
          {!loading && (
            <div 
              className="d-flex gap-2" 
              style={{ 
                marginTop: "4px",
                overflowX: "auto",
                paddingBottom: "4px",
                scrollbarWidth: "thin",
                scrollbarColor: "#22c55e #dcfce7"
              }}
            >
              {list.length === 0 ? (
                <div 
                  className="d-flex flex-column align-items-center justify-content-center w-100"
                  style={{ 
                    minHeight: "140px",
                    padding: "24px 16px",
                    textAlign: "center"
                  }}
                >
                  <div 
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(34, 197, 94, 0.1) 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "12px"
                    }}
                  >
                    <i className="fa fa-user-plus" style={{ fontSize: "28px", color: "#10b981" }}></i>
                  </div>
                  <h6 style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>
                    No New Joiners
                  </h6>
                  <p style={{ fontSize: "12px", color: "#6b7280", margin: 0 }}>
                    No new employees joined in the last 30 days
                  </p>
                </div>
              ) : (
                list.map((item, index) => (
                  <div 
                    key={index} 
                    style={{ 
                      minWidth: "140px",
                      width: "140px",
                      borderRadius: "12px",
                      background: "#ffffff",
                      border: "1px solid #dcfce7",
                      padding: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      position: "relative",
                      overflow: "visible"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.12)";
                      e.currentTarget.style.borderColor = "#22c55e";
                      e.currentTarget.style.borderWidth = "1px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.04)";
                      e.currentTarget.style.borderColor = "#dcfce7";
                      e.currentTarget.style.borderWidth = "1px";
                    }}
                    onClick={() => window.location.href = `/company-directory/${item.id}`}
                  >
                    {/* Avatar */}
                    <div className="d-flex justify-content-center mb-2">
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          background: "#f0f0f0"
                        }}
                      >
                        <Image 
                          src={item?.profile_image} 
                          type="user" 
                          style={{ 
                            objectFit: "cover",
                            width: "100%",
                            height: "100%"
                          }} 
                        />
                      </div>
                    </div>

                    {/* Name and Details */}
                    <div className="text-center">
                      <Link 
                        to={`/company-directory/${item.id}`}
                        style={{
                          textDecoration: "none",
                          color: "#1a1a1a",
                          fontWeight: "400",
                          fontSize: "13px",
                          display: "block",
                          marginBottom: "3px",
                          transition: "color 0.2s ease",
                          lineHeight: "1.3",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        onMouseEnter={(e) => e.target.style.color = "#10b981"}
                        onMouseLeave={(e) => e.target.style.color = "#1a1a1a"}
                      >
                        {item?.first_name} {item?.last_name}
                      </Link>
                      {item?.emp_no && (
                        <span 
                          style={{ 
                            fontSize: "11px", 
                            color: "#6b7280",
                            fontWeight: "500",
                            display: "block",
                            marginBottom: "8px"
                          }}
                        >
                          {item?.emp_no}
                        </span>
                      )}
                      
                      {/* Join Date */}
                      <div 
                        style={{
                          padding: "6px 10px",
                          borderRadius: "6px",
                          background: "linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(34, 197, 94, 0.05) 100%)",
                          border: "1px solid #dcfce7"
                        }}
                      >
                        <div style={{ fontSize: "10px", color: "#6b7280", fontWeight: "500", marginBottom: "2px" }}>
                          Joined on
                        </div>
                        <div style={{ fontSize: "11px", color: "#10b981", fontWeight: "600" }}>
                          {formatDateHandler(item.employment_date)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Modern Resigned/Left Card Component
  const ResignedCard = ({ loading, list, count }) => {
    return (
      <div 
        className="card flex-fill" 
        style={{ 
          borderRadius: "16px", 
          border: "none",
          background: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 50%, #fecaca 100%)",
          boxShadow: "0 4px 20px rgba(239, 68, 68, 0.08), 0 2px 8px rgba(239, 68, 68, 0.06)",
          overflow: "hidden",
          position: "relative"
        }}
      >
        {/* Decorative background elements */}
        <div 
          style={{
            position: "absolute",
            top: "-30px",
            right: "-30px",
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%)",
            zIndex: 0
          }}
        />

        <div className="card-body d-flex flex-column p-3" style={{ position: "relative", zIndex: 1 }}>
          {/* Header Section */}
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="d-flex align-items-center gap-2">
              <div 
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 3px 10px rgba(239, 68, 68, 0.2)"
                }}
              >
                <i className="fa fa-user-minus" style={{ fontSize: "18px", color: "#ffffff" }}></i>
              </div>
              <div>
                <h5 className="mb-0" style={{ fontSize: "16px", fontWeight: "700", color: "#1a1a1a", margin: 0, lineHeight: "1.2" }}>
                  Resigned/Left
                </h5>
                <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500" }}>
                  {loading ? (
                    <div className="shimmer shimmer-text" style={{width: "120px", height: "12px", borderRadius: "4px"}}></div>
                  ) : (
                    `${count} ${count === 1 ? "employee resigned" : "employees resigned"} in last 30 days`
                  )}
                </span>
              </div>
            </div>
          </div>
  
          {/* Loading State */}
          {loading && (
            <div className="d-flex gap-2" style={{ marginTop: "4px" }}>
              {[1, 2, 3].map((i) => (
                <div 
                  key={i}
                  style={{
                    width: "140px",
                    minWidth: "140px",
                    height: "130px",
                    borderRadius: "10px",
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb"
                  }}
                >
                  <SkeltonLoader number={1} active={true} className="col-12" height={130} />
                </div>
              ))}
            </div>
          )}
  
          {/* Resigned Cards */}
          {!loading && (
            <div 
              className="d-flex gap-2" 
              style={{ 
                marginTop: "4px",
                overflowX: "auto",
                paddingBottom: "4px",
                scrollbarWidth: "thin",
                scrollbarColor: "#dc2626 #fee2e2"
              }}
            >
              {list.length === 0 ? (
                <div 
                  className="d-flex flex-column align-items-center justify-content-center w-100"
                  style={{ 
                    minHeight: "140px",
                    padding: "24px 16px",
                    textAlign: "center"
                  }}
                >
                  <div 
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "12px"
                    }}
                  >
                    <i className="fa fa-user-minus" style={{ fontSize: "28px", color: "#ef4444" }}></i>
                  </div>
                  <h6 style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>
                    No Resignations
                  </h6>
                  <p style={{ fontSize: "12px", color: "#6b7280", margin: 0 }}>
                    No employees resigned in the last 30 days
                  </p>
                </div>
              ) : (
                list.map((item, index) => (
                  <div 
                    key={index} 
                    style={{ 
                      minWidth: "140px",
                      width: "140px",
                      borderRadius: "12px",
                      background: "#ffffff",
                      border: "1px solid #fee2e2",
                      padding: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      position: "relative",
                      overflow: "visible"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(239, 68, 68, 0.12)";
                      e.currentTarget.style.borderColor = "#f87171";
                      e.currentTarget.style.borderWidth = "1px";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.04)";
                      e.currentTarget.style.borderColor = "#fee2e2";
                      e.currentTarget.style.borderWidth = "1px";
                    }}
                    onClick={() => window.location.href = `/company-directory/${item.id}`}
                  >
                    {/* Avatar */}
                    <div className="d-flex justify-content-center mb-2">
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          background: "#f0f0f0"
                        }}
                      >
                        <Image 
                          src={item?.profile_image} 
                          type="user" 
                          style={{ 
                            objectFit: "cover",
                            width: "100%",
                            height: "100%"
                          }} 
                        />
                      </div>
                    </div>

                    {/* Name and Details */}
                    <div className="text-center">
                      <Link 
                        to={`/company-directory/${item.id}`}
                        style={{
                          textDecoration: "none",
                          color: "#1a1a1a",
                          fontWeight: "400",
                          fontSize: "13px",
                          display: "block",
                          marginBottom: "3px",
                          transition: "color 0.2s ease",
                          lineHeight: "1.3",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        onMouseEnter={(e) => e.target.style.color = "#ef4444"}
                        onMouseLeave={(e) => e.target.style.color = "#1a1a1a"}
                      >
                        {item?.first_name} {item?.last_name}
                      </Link>
                      {item?.emp_no && (
                        <span 
                          style={{ 
                            fontSize: "11px", 
                            color: "#6b7280",
                            fontWeight: "500",
                            display: "block",
                            marginBottom: "8px"
                          }}
                        >
                          {item?.emp_no}
                        </span>
                      )}
                      
                      {/* Resignation Date */}
                      {item?.termination_date && (
                        <div 
                          style={{
                            padding: "6px 10px",
                            borderRadius: "6px",
                            background: "linear-gradient(135deg, rgba(239, 68, 68, 0.05) 0%, rgba(220, 38, 38, 0.05) 100%)",
                            border: "1px solid #fee2e2"
                          }}
                        >
                          <div style={{ fontSize: "10px", color: "#6b7280", fontWeight: "500", marginBottom: "2px" }}>
                            Resigned on
                          </div>
                          <div style={{ fontSize: "11px", color: "#ef4444", fontWeight: "600" }}>
                            {formatDateHandler(item.termination_date)}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    );
  };
  

  

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid pb-0">
          {/* Leave Alert */}
          {/* /Leave Alert */}
          <div className="row mb-4">
            <div className="col-lg-12">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h2 style={{ 
                    fontSize: "28px", 
                    fontWeight: "400", 
                    color: "#1a1a1a",
                    marginBottom: "8px"
                  }}>
                    {greeting}, {user?.first_name}! 👋
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <style>{`
            @media (max-width: 576px) {
              .announcement-section {
                margin-bottom: 0.5rem !important;
              }
              .announcement-section .row.g-3 {
                --bs-gutter-y: 0.5rem !important;
                margin-bottom: 0.5rem !important;
              }
              .announcement-section .col-lg-8 {
                margin-bottom: 0.5rem !important;
              }
            }
          `}</style>
          <div className="row mb-0 announcement-section">
            <div className="col-lg-12 col-md-12">
              <div className="row d-flex mb-0" style={{ alignItems: "stretch" }}>
                {/* Employee Details */}

                <div className="col-lg-8 col-md-12 d-flex" style={{ alignItems: "stretch", paddingTop: "0" }}>
                  <div className="w-100 h-100" style={{ paddingTop: "0", marginTop: "0", display: "flex", flexDirection: "column" }}>
                    <div className="row g-3 mb-0 d-flex flex-grow-1" style={{ alignItems: "stretch", marginTop: "0", paddingTop: "0", flex: 1 }}>
                      <div className="col-lg-6 col-md-6 col-sm-12 d-flex" style={{ alignItems: "stretch" }}>
                        {announcementsLoading ? (
                          <div className="card shadow-sm w-100 h-100" style={{ borderRadius: "12px", overflow: "hidden", border: "1px solid #e0e0e0", aspectRatio: "4/3" }}>
                            <SkeltonLoader number={1} active={true} className="col-12" style={{ height: "100%" }} />
                          </div>
                        ) : announcements.length > 0 ? (
                          <div className="card shadow-sm w-100 h-100" style={{ borderRadius: "12px", overflow: "hidden", border: "1px solid #e0e0e0", aspectRatio: "4/3" }}>
                            <Carousel indicators={false} controls={announcements.length > 1} style={{ height: "100%" }}>
                              {announcements.map((announcement) => (
                                <Carousel.Item key={announcement.id} style={{ height: "100%" }}>
                                  <div 
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      aspectRatio: "4/3",
                                      overflow: "hidden",
                                      position: "relative",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center"
                                    }}
                                  >
                                    <img 
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                        minWidth: "100%",
                                        minHeight: "100%"
                                      }} 
                                      src={imageKitResize(announcement.image, 800, 600)}
                                      alt={announcement.title || "Announcement"}
                                    />
                                    {(announcement.title || announcement.description) && (
                                      <div style={{
                                        position: "absolute",
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        padding: "16px"
                                      }}>
                                        <div style={{
                                          backgroundColor: "rgba(0, 0, 0, 0.75)",
                                          borderRadius: "8px",
                                          padding: "16px",
                                          color: "white"
                                        }}>
                                          {announcement.title && (
                                            <h5 style={{ 
                                              margin: 0, 
                                              fontSize: "18px", 
                                              fontWeight: "400", 
                                              color: "white"
                                            }}>
                                              {announcement.title}
                                            </h5>
                                          )}
                                          {announcement.description && (
                                            <p style={{ 
                                              margin: announcement.title ? "8px 0 0" : "0", 
                                              fontSize: "14px", 
                                              color: "white"
                                            }}>
                                              {announcement.description}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </Carousel.Item>
                              ))}
                            </Carousel>
                          </div>
                        ) : (
                          <div className="card shadow-sm w-100 h-100" style={{ borderRadius: "12px", padding: "40px", textAlign: "center", border: "1px solid #e0e0e0", aspectRatio: "4/3", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <p className="text-muted mb-0">No announcements available</p>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 d-flex" style={{ alignItems: "stretch" }}>
                        <div className="card shadow-sm w-100 h-100" style={{ 
                          borderRadius: "12px", 
                          border: "1px solid #e0e0e0",
                          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          color: "white",
                          aspectRatio: "4/3",
                          display: "flex",
                          flexDirection: "column"
                        }}>
                          <div className="card-body p-3 d-flex flex-column h-100" style={{ overflow: "hidden", boxSizing: "border-box" }}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h5 className="mb-0" style={{ fontSize: "16px", fontWeight: "600", color: "white" }}>
                                Upcoming Holidays
                              </h5>
                            </div>
                            {publicHoliday && publicHoliday.length > 0 ? (
                              <div className="d-flex flex-column flex-grow-1">
                                <div className="d-flex align-items-center p-2" style={{ 
                                  backgroundColor: "rgba(255, 255, 255, 0.2)", 
                                  borderRadius: "8px",
                                  backdropFilter: "blur(10px)"
                                }}>
                                  <div className="me-2">
                                    <img src={holidaycalendar} alt="Icon" style={{ width: "32px", height: "32px", filter: "brightness(0) invert(1)" }} />
                                  </div>
                                  <div className="flex-grow-1">
                                    <h6 className="mb-0" style={{ fontSize: "14px", fontWeight: "600", color: "white" }}>
                                      {publicHoliday[0]?.name}
                                    </h6>
                                    <p className="mb-0" style={{ fontSize: "12px", color: "rgba(255, 255, 255, 0.9)" }}>
                                      {publicHoliday[0]?.date}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="d-flex flex-column align-items-center justify-content-center flex-grow-1 text-center">
                                <div className="mb-2" style={{ fontSize: "36px", opacity: 0.8 }}>
                                  🎉
                                </div>
                                <p className="mb-1" style={{ color: "rgba(255, 255, 255, 0.95)", fontSize: "14px", fontWeight: "500" }}>
                                  No upcoming holidays
                                </p>
                                <p className="mb-0" style={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "12px" }}>
                                  Check back soon for updates
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                {/* /Employee Details */}
                {/* Attendance & Leaves */}
                <div className="col-lg-4 col-md-12 d-flex mt-sm-3" style={{ marginTop: "0", alignItems: "stretch", paddingTop: "0" }}>
                  <div 
                    className="card shadow-sm w-100 h-100" 
                    style={{ 
                      borderRadius: "16px", 
                      border: "none",
                      background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 50%, #a7f3d0 100%)",
                      boxShadow: "0 4px 20px rgba(16, 185, 129, 0.08), 0 2px 8px rgba(16, 185, 129, 0.06)",
                      display: "flex", 
                      flexDirection: "column", 
                      aspectRatio: "4/3",
                      overflow: "hidden",
                      position: "relative"
                    }}
                  >
                    {/* Decorative background elements */}
                    <div 
                      style={{
                        position: "absolute",
                        top: "-30px",
                        right: "-30px",
                        width: "120px",
                        height: "120px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(34, 197, 94, 0.1) 100%)",
                        filter: "blur(20px)",
                        zIndex: 0
                      }}
                    />
                    <div 
                      style={{
                        position: "absolute",
                        bottom: "-20px",
                        left: "-20px",
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(34, 197, 94, 0.08) 100%)",
                        filter: "blur(15px)",
                        zIndex: 0
                      }}
                    />

                    <div className="card-body p-3 d-flex flex-column h-100" style={{ overflow: "hidden", boxSizing: "border-box", position: "relative", zIndex: 1 }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div className="d-flex align-items-center">
                            <div 
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "12px",
                                background: "linear-gradient(135deg, #10b981 0%, #22c55e 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 3px 10px rgba(16, 185, 129, 0.2)",
                                marginRight: "12px"
                              }}
                            >
                              <i className="la la-calendar-check" style={{ fontSize: "20px", color: "#ffffff" }}></i>
                            </div>
                            <div>
                              <h5 className="mb-0" style={{ fontSize: "16px", fontWeight: "700", color: "#1a1a1a", letterSpacing: "0.3px" }}>Leaves</h5>
                              <p className="mb-0" style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>
                                {leaves?.employees?.length || 0} {leaves?.employees?.length === 1 ? 'employee' : 'employees'} on leave
                              </p>
                            </div>
                          </div>
                          <select
                            className="form-select form-select-sm"
                            style={{ 
                              width: "110px", 
                              fontSize: "12px",
                              borderRadius: "8px",
                              border: "1px solid rgba(16, 185, 129, 0.2)",
                              background: "rgba(255, 255, 255, 0.9)",
                              padding: "6px 28px 6px 10px",
                              fontWeight: "600",
                              color: "#1a1a1a",
                              boxShadow: "0 2px 6px rgba(16, 185, 129, 0.1)",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              WebkitAppearance: "none",
                              MozAppearance: "none",
                              appearance: "none"
                            }}
                            value={leaveFilter}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              setLeaveFilter(newValue);
                              localStorage.setItem("leaveFilter", newValue);
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.boxShadow = "0 4px 10px rgba(16, 185, 129, 0.2)";
                              e.target.style.transform = "translateY(-1px)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.boxShadow = "0 2px 6px rgba(16, 185, 129, 0.1)";
                              e.target.style.transform = "translateY(0)";
                            }}
                          >
                            <option value="today" style={{ color: "#1a1a1a", background: "#fff" }}>Today</option>
                            <option value="week" style={{ color: "#1a1a1a", background: "#fff" }}>This Week</option>
                            <option value="month" style={{ color: "#1a1a1a", background: "#fff" }}>This Month</option>
                          </select>
                          <style>{`
                            select.form-select-sm option {
                              color: #1a1a1a !important;
                              background: #fff !important;
                            }
                            select.form-select-sm {
                              color: #1a1a1a !important;
                            }
                            select.form-select-sm:focus {
                              color: #1a1a1a !important;
                            }
                          `}</style>
                        </div>

                        <div className="leaves-list flex-grow-1" style={{ overflowY: "auto", paddingRight: "4px" }}>
                            {leavesLoading ? (
                              <SkeltonLoader number={2} active={true} className="col-12" height={50} />
                            ) : leaves?.employees?.length > 0 ? (
                              leaves?.employees?.map((emp) => (
                                <Popover
                                  key={emp.id}
                                  content={
                                    <div style={{ padding: "8px" }}>
                                      <p style={{ margin: "4px 0", fontSize: "13px", fontWeight: "600" }}>Leave Details</p>
                                      <p style={{ margin: "4px 0", fontSize: "12px" }}>Start: {formatDateHandler(emp.start_date)}</p>
                                      <p style={{ margin: "4px 0", fontSize: "12px" }}>End: {formatDateHandler(emp.end_date)}</p>
                                      <p style={{ margin: "4px 0", fontSize: "12px" }}>Days: {emp.no_of_days || 1}</p>
                                    </div>
                                  }
                                  trigger="hover"
                                  placement="top"
                                  open={openPopoverIds.includes(emp.id)}
                                  onOpenChange={(open) => {
                                    if (open) {
                                      setOpenPopoverIds([emp.id]);
                                    } else {
                                      setOpenPopoverIds(openPopoverIds.filter(id => id !== emp.id));
                                    }
                                  }}
                                >
                                  <div 
                                    className="d-flex justify-content-between align-items-center p-2 mb-2" 
                                    style={{ 
                                      cursor: 'pointer', 
                                      borderRadius: "10px",
                                      transition: "all 0.2s ease",
                                      border: "1px solid transparent",
                                      background: "rgba(255, 255, 255, 0.6)",
                                      backdropFilter: "blur(10px)"
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
                                      e.currentTarget.style.borderColor = "rgba(16, 185, 129, 0.3)";
                                      e.currentTarget.style.transform = "translateX(4px)";
                                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(16, 185, 129, 0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.6)";
                                      e.currentTarget.style.borderColor = "transparent";
                                      e.currentTarget.style.transform = "translateX(0)";
                                      e.currentTarget.style.boxShadow = "none";
                                    }}
                                  >
                                    <div className="flex-grow-1">
                                      <p className="mb-1" style={{ fontSize: "13px", fontWeight: "600", color: "#1a1a1a", margin: 0 }}>
                                        {`${emp?.company_user?.first_name} ${emp?.company_user?.last_name}`}
                                      </p>
                                      <p className="mb-0" style={{ fontSize: "11px", color: "#6b7280", margin: 0 }}>
                                        {emp?.company_user?.emp_no} • {emp?.cost_center?.name}
                                      </p>
                                    </div>
                                    <div className="ms-2">
                                      <span 
                                        className="badge" 
                                        style={{ 
                                          fontSize: "10px", 
                                          padding: "4px 10px",
                                          background: "linear-gradient(135deg, #10b981 0%, #22c55e 100%)",
                                          color: "#ffffff",
                                          borderRadius: "6px",
                                          fontWeight: "600",
                                          boxShadow: "0 2px 4px rgba(16, 185, 129, 0.2)"
                                        }}
                                      >
                                        {emp?.position?.name}
                                      </span>
                                    </div>
                                  </div>
                                </Popover>
                              ))
                            ) : (
                              <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "100%", padding: "20px", textAlign: "center" }}>
                                <div style={{ fontSize: "32px", opacity: 0.6, marginBottom: "8px" }}>
                                  🏖️
                                </div>
                                <p style={{ fontSize: "13px", color: "#6b7280", fontWeight: "500", margin: 0 }}>
                                  No leaves scheduled
                                </p>
                                <p style={{ fontSize: "11px", color: "#9ca3af", margin: "4px 0 0 0" }}>
                                  All employees are present
                                </p>
                              </div>
                            )}
                          </div>
                    </div>
                  </div>

                </div>
                {/* /Attendance & Leaves */}
              </div>
            </div>
          </div>

          <div className="row mt-4">
          <div className="col-xl-6 col-md-12 d-flex">
              <BirthdayCard
                loading={birthdayLoading}
                list={birthdays}
                count={birthdays.length}
              />
            </div>
            <div className="col-xl-6 col-md-12 d-flex">
              <AnniversaryCard
                loading={anniversaryLoading}
                list={anniversary}
                count={anniversary.length}
              />
            </div>

           
          </div>

          <div className="row">
        
          {
              user?.role?.access_scope !== "self" && 
              <div className="col-xl-6 col-md-12 d-flex">
              <NewJoinersCard
                loading={newJoinersLoading}
                list={newJoiners}
                count={newJoiners.length}
              />
            </div>
            }
           
            {/* /Company Policy */}
            {
              user?.role?.access_scope !== "self" && 
              <div className="col-xl-6 col-md-12 d-flex">
              <ResignedCard
                loading={terminatedLoading}
                list={terminated}
                count={terminated.length}
              />
            </div>
            }

           
          </div>

          {/* Document Expiry Cards Row */}
          <div className="row">
            <div className="col-xl-6 col-md-12 d-flex">
              <DocumentExpiryCard
                title="User Document Expiry"
                data={userDocumentExpiry}
                filter={userExpiryFilter}
                setFilter={setUserExpiryFilter}
                loading={documentExpiryLoading}
                type="user"
                icon="👤📄"
              />
            </div>
            <div className="col-xl-6 col-md-12 d-flex">
              <DocumentExpiryCard
                title="Store Document Expiry"
                data={storeDocumentExpiry}
                filter={storeExpiryFilter}
                setFilter={setStoreExpiryFilter}
                loading={documentExpiryLoading}
                type="store"
                icon="🏪📄"
              />
            </div>
          </div>
          {/* End Document Expiry Cards Row */}
        </div>
        {/* /Page Content */}
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default EmployeeDashboard;
